var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:url(#Sfumatura_senza_nome_35);}.cls-5{opacity:0.29;}.cls-6{fill:url(#Sfumatura_senza_nome_40);}.cls-7{mask:url(#mask);}.cls-8{mask:url(#mask-2-2);}.cls-9{fill:#d0c6ac;}.cls-10{mask:url(#mask-3);}.cls-11{fill:#edb989;}.cls-12{mask:url(#mask-4-2);}.cls-13,.cls-20,.cls-21,.cls-25{fill:#010101;}.cls-13{fill-opacity:0.1;}.cls-14{fill:#b7c1db;}.cls-15{mask:url(#mask-5);}.cls-16{fill:#f15e5f;}.cls-17{mask:url(#mask-6-3);}.cls-18{fill:#f4f4f4;}.cls-19{mask:url(#mask-7);}.cls-20{fill-opacity:0.16;}.cls-21{fill-opacity:0.7;}.cls-22{mask:url(#mask-8);}.cls-23{mask:url(#mask-9);}.cls-24{fill:#f0526e;}.cls-25{fill-opacity:0.6;}.cls-26{mask:url(#mask-10);}.cls-27{fill:#28354b;}.cls-28{mask:url(#mask-11);}.cls-29{fill:#4b322d;}.cls-30{fill:url(#Sfumatura_senza_nome_16);}.cls-31{fill:url(#Sfumatura_senza_nome_16-2);}.cls-32{fill:#f1f2f2;}.cls-33{fill:#4ebfa9;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 254.76,
    cy: 258,
    r: 253
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_35",
    y1: 512,
    x2: 512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#69bc94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5fa58a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#4e807b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#374d67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#211c53"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Sfumatura_senza_nome_40",
    cx: 256,
    cy: 219.69,
    r: 109.69,
    gradientTransform: "translate(-183.39 475.69) rotate(-90) scale(1 2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6cc196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#446972"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#2b315c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#211c53"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 146.31,
    y: 110,
    width: 219.39,
    height: 219.39,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    className: "cls-1",
    cx: 256,
    cy: 219.69,
    r: 109.69
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2-2",
    x: 151.43,
    y: 112.68,
    width: 204.9,
    height: 217.32,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    className: "cls-1",
    d: "M160.75,236.86a93.14,93.14,0,1,0,186.27,0h9.31V112.68H151.43V236.86Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 151.43,
    y: 140.62,
    width: 204.9,
    height: 189.38,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-5",
    className: "cls-1",
    d: "M272.51,252.86v14.27h3.11A55.88,55.88,0,0,1,331.5,323v7H176.27v-7a55.88,55.88,0,0,1,55.88-55.88h3.11V252.86a43.48,43.48,0,0,1-24.6-34.72,9.32,9.32,0,0,1-8-9.22V198.06a9.32,9.32,0,0,1,7.76-9.19v-4.78h0a43.47,43.47,0,0,1,43.46-43.47h0a43.47,43.47,0,0,1,43.47,43.47v4.78a9.32,9.32,0,0,1,7.76,9.19v10.86a9.32,9.32,0,0,1-8,9.22A43.48,43.48,0,0,1,272.51,252.86Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4-2",
    x: 176.27,
    y: 140.62,
    width: 155.23,
    height: 189.38,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-6-2",
    "data-name": "mask-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-5-2",
    "data-name": "path-5",
    className: "cls-1",
    d: "M272.51,252.86v14.27h3.11A55.88,55.88,0,0,1,331.5,323v7H176.27v-7a55.88,55.88,0,0,1,55.88-55.88h3.11V252.86a43.48,43.48,0,0,1-24.6-34.72,9.32,9.32,0,0,1-8-9.22V198.06a9.32,9.32,0,0,1,7.76-9.19v-4.78h0a43.47,43.47,0,0,1,43.46-43.47h0a43.47,43.47,0,0,1,43.47,43.47v4.78a9.32,9.32,0,0,1,7.76,9.19v10.86a9.32,9.32,0,0,1-8,9.22A43.48,43.48,0,0,1,272.51,252.86Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 151.43,
    y: 244.62,
    width: 204.9,
    height: 85.38,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "react-mask-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "react-path-39",
    className: "cls-1",
    d: "M235.26,254.77c-13.91,1.56-24.62,5.81-24.84,16.74A55.9,55.9,0,0,0,176.27,323h0v7H331.5v-7a55.91,55.91,0,0,0-34.16-51.5c-.21-10.93-10.92-15.18-24.83-16.74v14.69h0a18.63,18.63,0,0,1-18.63,18.63h0a18.63,18.63,0,0,1-18.62-18.63Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6-3",
    x: 176.27,
    y: 254.77,
    width: 155.23,
    height: 75.23,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "react-mask-40-2",
    "data-name": "react-mask-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "react-path-39-2",
    "data-name": "react-path-39",
    className: "cls-1",
    d: "M235.26,254.77c-13.91,1.56-24.62,5.81-24.84,16.74A55.9,55.9,0,0,0,176.27,323h0v7H331.5v-7a55.91,55.91,0,0,0-34.16-51.5c-.21-10.93-10.92-15.18-24.83-16.74v14.69h0a18.63,18.63,0,0,1-18.63,18.63h0a18.63,18.63,0,0,1-18.62-18.63Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    x: 176.27,
    y: 254.5,
    width: 155.23,
    height: 75.5,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "react-mask-40-3",
    "data-name": "react-mask-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "react-path-39-3",
    "data-name": "react-path-39",
    className: "cls-1",
    d: "M235.26,254.77c-13.91,1.56-24.62,5.81-24.84,16.74A55.9,55.9,0,0,0,176.27,323h0v7H331.5v-7a55.91,55.91,0,0,0-34.16-51.5c-.21-10.93-10.92-15.18-24.83-16.74v14.69h0a18.63,18.63,0,0,1-18.63,18.63h0a18.63,18.63,0,0,1-18.62-18.63Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    x: 239.22,
    y: 218.24,
    width: 29.33,
    height: 23.28,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "react-mask-68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "react-path-67",
    className: "cls-1",
    d: "M239.23,228.43a14.75,14.75,0,0,0,29.32-.07,1.63,1.63,0,0,0-1.44-1.59H240.76A1.66,1.66,0,0,0,239.23,228.43Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    x: 239.22,
    y: 226.77,
    width: 29.33,
    height: 25.61,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "react-mask-68-2",
    "data-name": "react-mask-68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "react-path-67-2",
    "data-name": "react-path-67",
    className: "cls-1",
    d: "M239.23,228.43a14.75,14.75,0,0,0,29.32-.07,1.63,1.63,0,0,0-1.44-1.59H240.76A1.66,1.66,0,0,0,239.23,228.43Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    x: 151.43,
    y: 112.68,
    width: 204.9,
    height: 217.32,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "react-mask-139"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "react-path-141",
    className: "cls-1",
    x: 151.43,
    y: 112.68,
    width: 204.9,
    height: 217.32
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    x: 150.66,
    y: 112.68,
    width: 204.9,
    height: 217.32,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "react-mask-138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "react-path-140",
    className: "cls-1",
    d: "M223.81,153.06c.1,0-.14-.06-.71-.05.69,0,.93,0,.71.05m-6.31-12.2s0,.11,0,0m83.55,26.75a49.27,49.27,0,0,0-1.18-7.65,41.34,41.34,0,0,0-1.93-5.82c-.48-1.15-1.58-2.73-1.71-4s.83-2.58,1-4a12.21,12.21,0,0,0-.12-4.22,8.59,8.59,0,0,0-6.1-6.84c-.74-.18-2.3,0-2.82-.39s-1-2.17-1.56-2.85a7,7,0,0,0-6.49-2.73c-1.87.32-.8.71-2.2-.39-.78-.62-1.36-1.55-2.12-2.21a19.14,19.14,0,0,0-3.8-2.55,39.43,39.43,0,0,0-11.52-3.81c-7.21-1.18-14.9-.15-21.88,1.72a58.9,58.9,0,0,0-10.21,3.68,10.4,10.4,0,0,1-3.62,1.41c-2.28.27-4.2.26-6.35,1.22-6.63,3-9.61,9.85-7,16.44a11.61,11.61,0,0,0,2.19,3.56c1.18,1.3,1.61,1,.59,2.54a41.13,41.13,0,0,0-3.84,7.12c-2.74,6.52-3.2,13.87-3,20.82a55.8,55.8,0,0,0,.55,7.31c.17,1,.21,3,1,3.78a1.57,1.57,0,0,0,1.52.46c1.33-.37.87-1.35.9-2.26.16-4.56,0-8.6,1-13.12a34.49,34.49,0,0,1,3.87-9.34,55.57,55.57,0,0,1,7.61-10.36c.71-.77.87-1.09,1.82-1.14a10.09,10.09,0,0,1,2.49.62c1.55.38,3.1.75,4.68,1a45.29,45.29,0,0,0,8.71.4,77.75,77.75,0,0,0,17.14-2c3.71-1,7-2.7,10.55-4a6.58,6.58,0,0,1,1.11-.64,18.21,18.21,0,0,1,1.76,1.6c1.73,1.35,3.62,1.92,5.49,3,2.3,1.29.07-.56,1.34,1.05a15.94,15.94,0,0,1,.86,1.87,13.91,13.91,0,0,0,3.82,4.37c1.52,1.14,3.8,1.69,4.57,3.18a40.13,40.13,0,0,1,1.28,3.93,80.83,80.83,0,0,0,4.6,9.22c1.35,2.44,2.82,4.56,3,7.35.05,1-.87,6.78,1.37,5,.33-.26,1.05-3.22,1.2-3.73a40.29,40.29,0,0,0,1.08-6.27,57.33,57.33,0,0,0,.37-12.35"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_16",
    x1: 142.83,
    y1: 213.58,
    x2: 33.59,
    y2: 213.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ebfa9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#69b193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#af8e59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f36b21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_16-2",
    x1: 369.17,
    y1: 213.58,
    x2: 478.41,
    y2: 213.58,
    xlinkHref: "#Sfumatura_senza_nome_16"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dev_logo_circle_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", {
    id: "Circle",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circle-Background"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "path-1-2",
    "data-name": "path-1",
    className: "cls-6",
    cx: 256,
    cy: 219.69,
    r: 109.69
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color_Palette_Blue-01",
    "data-name": "Color/Palette/Blue-01"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_Color",
    "data-name": "Color",
    className: "cls-6",
    x: 146.31,
    y: 110,
    width: 219.39,
    height: 219.39
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avataaar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-5-3",
    "data-name": "path-5",
    className: "cls-9",
    d: "M272.51,252.86v14.27h3.11A55.88,55.88,0,0,1,331.5,323v7H176.27v-7a55.88,55.88,0,0,1,55.88-55.88h3.11V252.86a43.48,43.48,0,0,1-24.6-34.72,9.32,9.32,0,0,1-8-9.22V198.06a9.32,9.32,0,0,1,7.76-9.19v-4.78h0a43.47,43.47,0,0,1,43.46-43.47h0a43.47,43.47,0,0,1,43.47,43.47v4.78a9.32,9.32,0,0,1,7.76,9.19v10.86a9.32,9.32,0,0,1-8,9.22A43.48,43.48,0,0,1,272.51,252.86Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Skin_-03-Brown",
    "data-name": "Skin/-03-Brown"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 151.43,
    y: 140.62,
    width: 204.9,
    height: 189.38
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Neck-Shadow",
    className: "cls-13",
    d: "M297.35,201.94v17.85a43.47,43.47,0,0,1-86.93,0v-6.21a43.47,43.47,0,0,0,86.93,0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clothing_Hoodie",
    "data-name": "Clothing/Hoodie"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hoodie"
  }, /*#__PURE__*/React.createElement("path", {
    id: "react-path-39-4",
    "data-name": "react-path-39",
    className: "cls-14",
    d: "M235.26,254.77c-13.91,1.56-24.62,5.81-24.84,16.74a56.13,56.13,0,0,0-24.6,20.25c-1.7,2.52-3.11,5.18-3.11,5.18s-.93,1.78-1.74,3.63c-1.44,3.29-3.52,11.43-4.7,22.44v7H331.5v-7c0-.52-.76-12.52-3.81-20.31a63.05,63.05,0,0,0-2.67-5.81s-1.4-2.65-3.07-5.13c-2.51-3.71-11.17-11.95-24.61-20.25-.21-10.93-10.92-15.18-24.83-16.74v14.69a18.63,18.63,0,1,1-37.25,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color_Palette_Gray-01",
    "data-name": "Color/Palette/Gray-01"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_Color-2",
    "data-name": "Color",
    className: "cls-16",
    x: 151.43,
    y: 244.62,
    width: 204.9,
    height: 85.38
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Straps",
    className: "cls-18",
    d: "M230.6,292.54V330h-5.43V289.76A50.3,50.3,0,0,0,230.6,292.54Zm52-2.78v31.31a2.72,2.72,0,1,1-5.43,0V292.54A50.3,50.3,0,0,0,282.6,289.76Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow",
    className: "cls-20",
    d: "M222,254.5c-11.68,2.21-19.76,6.61-19.76,15.2,0,15.3,25.64,27.7,51.61,27.7S305.5,285,305.5,269.7c0-8.59-8.08-13-19.76-15.2,7.05,2.6,11.61,7,11.61,14.24,0,15.83-21.6,28.66-43.47,28.66s-43.46-12.83-43.46-28.66C210.42,261.47,215,257.1,222,254.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Face"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mouth_Smile",
    "data-name": "Mouth/Smile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mouth"
  }, /*#__PURE__*/React.createElement("path", {
    id: "react-path-67-3",
    "data-name": "react-path-67",
    className: "cls-21",
    d: "M239.23,228.43a14.75,14.75,0,0,0,29.32-.07,1.63,1.63,0,0,0-1.44-1.59H240.76A1.66,1.66,0,0,0,239.23,228.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Teeth",
    className: "cls-1",
    x: 242.24,
    y: 218.24,
    width: 24.06,
    height: 12.42,
    rx: 3.88,
    ry: 3.88
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tongue"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 250,
    cy: 243.85,
    r: 8.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 257.76,
    cy: 243.85,
    r: 8.54
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Nose_Default",
    "data-name": "Nose/Default"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Nose",
    className: "cls-20",
    d: "M244.57,213.58c0,3.43,4.17,6.21,9.31,6.21h0c5.15,0,9.32-2.78,9.32-6.21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Eyes_Default-_",
    "data-name": "Eyes/Default-"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Eye",
    className: "cls-25",
    cx: 233.7,
    cy: 199.61,
    r: 4.66
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Eye-2",
    "data-name": "Eye",
    className: "cls-25",
    cx: 274.06,
    cy: 199.61,
    r: 4.66
  })), /*#__PURE__*/React.createElement("g", {
    id: "Eyebrow_Natural_Flat-Natural",
    "data-name": "Eyebrow/Natural/Flat-Natural"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    className: "cls-25",
    d: "M240.43,184.93a101.66,101.66,0,0,1-11.58-.09c-3-.13-6-.53-8.83.78-.54.25-3.52,1.77-3.45,2.6.06.67,3.06,1.7,3.6,1.89,2.84,1,5.57.7,8.5.52,3.59-.21,7.17-.06,10.76-.16,2.41-.08,6.14-.49,7.34-3.42a6.27,6.27,0,0,0-.28-3.61.58.58,0,0,0-.88-.31,11.6,11.6,0,0,1-5.18,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-10-2",
    "data-name": "Fill-10",
    className: "cls-25",
    d: "M267.34,184.93a101.68,101.68,0,0,0,11.58-.09c3-.13,6-.53,8.83.78.54.25,3.51,1.77,3.45,2.6-.06.67-3.06,1.7-3.6,1.89-2.85,1-5.57.7-8.5.52-3.59-.21-7.17-.06-10.76-.16-2.42-.08-6.14-.49-7.34-3.42a6.27,6.27,0,0,1,.28-3.61.57.57,0,0,1,.87-.31,11.68,11.68,0,0,0,5.19,1.8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Top"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top_Short-Hair_Short-Curly",
    "data-name": "Top/Short-Hair/Short-Curly"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Short-Hair"
  }, /*#__PURE__*/React.createElement("path", {
    id: "react-path-140-2",
    "data-name": "react-path-140",
    className: "cls-27",
    d: "M223.81,153.06c.1,0-.14-.06-.71-.05.69,0,.93,0,.71.05m-6.31-12.2s0,.11,0,0m83.55,26.75a49.27,49.27,0,0,0-1.18-7.65,41.34,41.34,0,0,0-1.93-5.82c-.48-1.15-1.58-2.73-1.71-4s.83-2.58,1-4a12.21,12.21,0,0,0-.12-4.22,8.59,8.59,0,0,0-6.1-6.84c-.74-.18-2.3,0-2.82-.39s-1-2.17-1.56-2.85a7,7,0,0,0-6.49-2.73c-1.87.32-.8.71-2.2-.39-.78-.62-1.36-1.55-2.12-2.21a19.14,19.14,0,0,0-3.8-2.55,39.43,39.43,0,0,0-11.52-3.81c-7.21-1.18-14.9-.15-21.88,1.72a58.9,58.9,0,0,0-10.21,3.68,10.4,10.4,0,0,1-3.62,1.41c-2.28.27-4.2.26-6.35,1.22-6.63,3-9.61,9.85-7,16.44a11.61,11.61,0,0,0,2.19,3.56c1.18,1.3,1.61,1,.59,2.54a41.13,41.13,0,0,0-3.84,7.12c-2.74,6.52-3.2,13.87-3,20.82a55.8,55.8,0,0,0,.55,7.31c.17,1,.21,3,1,3.78a1.57,1.57,0,0,0,1.52.46c1.33-.37.87-1.35.9-2.26.16-4.56,0-8.6,1-13.12a34.49,34.49,0,0,1,3.87-9.34,55.57,55.57,0,0,1,7.61-10.36c.71-.77.87-1.09,1.82-1.14a10.09,10.09,0,0,1,2.49.62c1.55.38,3.1.75,4.68,1a45.29,45.29,0,0,0,8.71.4,77.75,77.75,0,0,0,17.14-2c3.71-1,7-2.7,10.55-4a6.58,6.58,0,0,1,1.11-.64,18.21,18.21,0,0,1,1.76,1.6c1.73,1.35,3.62,1.92,5.49,3,2.3,1.29.07-.56,1.34,1.05a15.94,15.94,0,0,1,.86,1.87,13.91,13.91,0,0,0,3.82,4.37c1.52,1.14,3.8,1.69,4.57,3.18a40.13,40.13,0,0,1,1.28,3.93,80.83,80.83,0,0,0,4.6,9.22c1.35,2.44,2.82,4.56,3,7.35.05,1-.87,6.78,1.37,5,.33-.26,1.05-3.22,1.2-3.73a40.29,40.29,0,0,0,1.08-6.27,57.33,57.33,0,0,0,.37-12.35"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Skin_-03-Brown-2",
    "data-name": "Skin/-03-Brown"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color-2",
    "data-name": "Color"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 150.66,
    y: 112.68,
    width: 204.9,
    height: 217.32
  }))))))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M182.71,296.94c-.24.46-.49.94-.74,1.44s-.51,1.07-.74,1.58c2.47,2.3,4.75,4.21,6.7,5.75,2.53,2,4.59,3.47,5.61,4.17,1.88,1.3,3.89,2.6,6.05,3.89,1.13.67,2.24,1.31,3.33,1.91l3.18,1.64,3.09,1.6,4.63,2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M325,296.89c.11.06.08.08,1.3,2.8l1.37,3h0s-1.08.95-1.95,1.66c0,0-.8.67-1.94,1.56-4,3.06-7.33,5.3-7.33,5.3a111.83,111.83,0,0,1-13.26,7.43,98.54,98.54,0,0,1-13.1,5.41c-4.26,1.38-7.66,2.15-10.92,2.88-2.12.48-6.25,1.4-6.31,1.17-.11-.41,12.4-2.29,25.54-10a70.46,70.46,0,0,0,13.31-9.47C318,303,323.22,295.86,325,296.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M51.09,245.65l-17.5-21.93,67.57-76.42L142.83,142,75.26,218.38Zm27.67-22.86,45.49,57.07L82.58,285.2l-28-35.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M460.91,245.65l17.5-21.93L410.84,147.3,369.17,142l67.57,76.43Zm-27.67-22.86-45.49,57.07,41.67,5.34,28-35.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M129.64,375.6A10,10,0,0,1,123,378a13.71,13.71,0,0,1-5-.93,12,12,0,0,1-4.18-2.72A13.24,13.24,0,0,1,111,370a15.35,15.35,0,0,1-1.07-5.89,13.25,13.25,0,0,1,4-9.56,14,14,0,0,1,4.39-2.85,14.27,14.27,0,0,1,5.46-1,14.76,14.76,0,0,1,3.49.4,12.12,12.12,0,0,1,3.1,1.17,12,12,0,0,1,2.56,1.87,9.49,9.49,0,0,1,1.87,2.45l-5.51,4.22a6.24,6.24,0,0,0-2.4-2.57,6.36,6.36,0,0,0-3.38-1,5.55,5.55,0,0,0-2.43.53,5.62,5.62,0,0,0-1.9,1.49,7.16,7.16,0,0,0-1.26,2.26,9.41,9.41,0,0,0,0,5.75,6.68,6.68,0,0,0,1.28,2.23,5.57,5.57,0,0,0,2,1.44,6.18,6.18,0,0,0,2.55.51,7.56,7.56,0,0,0,5.7-2.66h-4.67v-5.32h11.09v14.37h-6.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M138.92,356.19v-6.08h7.22v6.08Zm0,21.66v-20h7.22v20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M182,377.85h-7.22V366.6a3.23,3.23,0,0,0-.59-2.15,1.84,1.84,0,0,0-1.43-.66,2.93,2.93,0,0,0-1.84.8,4.55,4.55,0,0,0-1.42,2.05v11.21h-7.22V366.6a3.23,3.23,0,0,0-.59-2.15,1.86,1.86,0,0,0-1.43-.66,2.91,2.91,0,0,0-1.84.8,4.65,4.65,0,0,0-1.43,2.05v11.21h-7.22v-20h6.5v3a6.8,6.8,0,0,1,2.93-2.49,10.48,10.48,0,0,1,4.41-.85,7.07,7.07,0,0,1,2.12.28,5.18,5.18,0,0,1,1.58.78,4.27,4.27,0,0,1,1.06,1.11,5.15,5.15,0,0,1,.63,1.29,7.22,7.22,0,0,1,2.91-2.55,9.33,9.33,0,0,1,4.2-.91,5.8,5.8,0,0,1,3.13.74,5.1,5.1,0,0,1,1.77,1.84,7.25,7.25,0,0,1,.8,2.36,16.38,16.38,0,0,1,.19,2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M217.73,377.85h-7.22V366.6a3.23,3.23,0,0,0-.59-2.15,1.84,1.84,0,0,0-1.43-.66,2.93,2.93,0,0,0-1.84.8,4.55,4.55,0,0,0-1.42,2.05v11.21H198V366.6a3.23,3.23,0,0,0-.59-2.15,1.86,1.86,0,0,0-1.43-.66,2.91,2.91,0,0,0-1.84.8,4.65,4.65,0,0,0-1.43,2.05v11.21H185.5v-20H192v3a6.8,6.8,0,0,1,2.93-2.49,10.48,10.48,0,0,1,4.41-.85,7.07,7.07,0,0,1,2.12.28,5.18,5.18,0,0,1,1.58.78,4.27,4.27,0,0,1,1.06,1.11,5.15,5.15,0,0,1,.63,1.29,7.22,7.22,0,0,1,2.91-2.55,9.33,9.33,0,0,1,4.2-.91,5.8,5.8,0,0,1,3.13.74,5.18,5.18,0,0,1,1.77,1.84,7.25,7.25,0,0,1,.8,2.36,16.38,16.38,0,0,1,.19,2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M220.77,379.86a8.84,8.84,0,0,0,3,.65c1.55,0,2.4-.89,2.55-2.66l-7.26-20h7.41l3.8,13.87,3.08-13.87H240l-6.76,22.38a9.64,9.64,0,0,1-1.29,2.68,8.66,8.66,0,0,1-2,2.05,8.86,8.86,0,0,1-2.56,1.31,9.31,9.31,0,0,1-2.93.46,9.85,9.85,0,0,1-3.72-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M260.06,371.39v6.46H242.47v-6.46h5.39v-7.57a3.64,3.64,0,0,1-1.06.9,13.57,13.57,0,0,1-1.62.82,11.88,11.88,0,0,1-1.8.6,6.51,6.51,0,0,1-1.64.23v-6.61a4.14,4.14,0,0,0,1.49-.4,17.71,17.71,0,0,0,1.9-.95,14,14,0,0,0,1.72-1.18,3.79,3.79,0,0,0,1-1.08h7.37v15.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M282.74,369.45A8,8,0,0,1,282,373a8.44,8.44,0,0,1-2.19,2.77,9.85,9.85,0,0,1-3.25,1.79,12.24,12.24,0,0,1-3.95.63,11.88,11.88,0,0,1-3.86-.63,10.19,10.19,0,0,1-3.25-1.8,9,9,0,0,1-2.24-2.86,8.27,8.27,0,0,1-.83-3.72,5.82,5.82,0,0,1,.3-1.9,6.92,6.92,0,0,1,.78-1.59,7.55,7.55,0,0,1,1.05-1.3,9.2,9.2,0,0,1,1.13-1,4.82,4.82,0,0,1-1.8-1.93,5.42,5.42,0,0,1-.7-2.62,6.53,6.53,0,0,1,.89-3.44,8.57,8.57,0,0,1,2.26-2.53,9.69,9.69,0,0,1,3-1.54,10.48,10.48,0,0,1,6.46,0,10.5,10.5,0,0,1,3.06,1.5,8.25,8.25,0,0,1,2.28,2.49,6.65,6.65,0,0,1,.89,3.44,5.54,5.54,0,0,1-.72,2.66,4.85,4.85,0,0,1-1.82,2,11.29,11.29,0,0,1,1.16,1,7,7,0,0,1,1,1.35,8,8,0,0,1,.76,1.67A6.32,6.32,0,0,1,282.74,369.45Zm-7.33-.42a2.38,2.38,0,0,0-.82-1.94,3.07,3.07,0,0,0-2-.68,3,3,0,0,0-2.05.7,2.44,2.44,0,0,0-.8,1.92,2.41,2.41,0,0,0,.82,1.86,3.12,3.12,0,0,0,4.08,0A2.46,2.46,0,0,0,275.41,369Zm-4.94-10a1.76,1.76,0,0,0,.67,1.52,2.31,2.31,0,0,0,1.42.49,2.44,2.44,0,0,0,1.45-.49,1.77,1.77,0,0,0,.68-1.52,1.67,1.67,0,0,0-.59-1.29,2.19,2.19,0,0,0-1.54-.54,2.12,2.12,0,0,0-1.52.54A1.69,1.69,0,0,0,270.47,359Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M285.21,365.65a9.3,9.3,0,0,1,.76-3.72,9,9,0,0,1,2.13-3,10.33,10.33,0,0,1,3.21-2,10.75,10.75,0,0,1,4-.74,10.08,10.08,0,0,1,4.32.89,8.58,8.58,0,0,1,3.17,2.61,12.22,12.22,0,0,1,2,4.17,21,21,0,0,1,.69,5.63,22.29,22.29,0,0,1-.74,6,13.29,13.29,0,0,1-2.15,4.49,9.59,9.59,0,0,1-3.42,2.83,10.19,10.19,0,0,1-4.56,1,11.77,11.77,0,0,1-8.59-3.65l4-4.64a6.49,6.49,0,0,0,4.72,2.06,3.89,3.89,0,0,0,2.94-1.13,4.62,4.62,0,0,0,1.16-3.17,6,6,0,0,1-4.1,1.29,10.59,10.59,0,0,1-3.79-.66,9.2,9.2,0,0,1-3-1.86,8.65,8.65,0,0,1-2-2.82A8.48,8.48,0,0,1,285.21,365.65Zm10.11-3.46a2.78,2.78,0,0,0-1.23.29,3.25,3.25,0,0,0-1,.76,3.76,3.76,0,0,0-.7,1.1,3.27,3.27,0,0,0-.27,1.31,3.05,3.05,0,0,0,1,2.26,3.17,3.17,0,0,0,2.28.93,3.13,3.13,0,0,0,2.28-.93,3,3,0,0,0,.95-2.26,3.44,3.44,0,0,0-.26-1.31,3.78,3.78,0,0,0-.71-1.1,3.32,3.32,0,0,0-1-.76A2.85,2.85,0,0,0,295.32,362.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M318,362.23h-10.3v-6.58h21.66l-13.19,27H308Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M324.27,380.21v-6.32h5.29v6.32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M333.38,380.21V355.8h9.38a13.74,13.74,0,0,1,5.33,1,10.72,10.72,0,0,1,6.19,6.48,14.77,14.77,0,0,1-.08,9.76,10.92,10.92,0,0,1-2.5,3.85,11.14,11.14,0,0,1-3.88,2.48,14,14,0,0,1-5.06.87ZM348.27,368a8.31,8.31,0,0,0-.38-2.57,5.92,5.92,0,0,0-1.09-2,4.85,4.85,0,0,0-1.73-1.29,5.57,5.57,0,0,0-2.31-.46h-2.68v12.72h2.68a5.47,5.47,0,0,0,2.34-.48,4.9,4.9,0,0,0,1.74-1.34,6,6,0,0,0,1.06-2A8.32,8.32,0,0,0,348.27,368Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M366.45,380.56a11.44,11.44,0,0,1-4.23-.74,8.89,8.89,0,0,1-3.11-2,8.73,8.73,0,0,1-1.91-2.93,9.42,9.42,0,0,1-.65-3.47,10.68,10.68,0,0,1,.64-3.71,8.47,8.47,0,0,1,1.89-3.06,9.19,9.19,0,0,1,3.09-2.08,12.25,12.25,0,0,1,8.55,0,9.39,9.39,0,0,1,3.11,2.06,8.74,8.74,0,0,1,1.89,3,10.19,10.19,0,0,1,.63,3.56,9.34,9.34,0,0,1-.05,1.05c0,.36-.07.67-.12.95H363.5a2.53,2.53,0,0,0,1.06,2.08,3.75,3.75,0,0,0,2.1.63,4.38,4.38,0,0,0,2-.48,2.39,2.39,0,0,0,1.25-1.34l5.54,1.58a8.65,8.65,0,0,1-3.39,3.54A10.69,10.69,0,0,1,366.45,380.56Zm2.89-11.31a3.46,3.46,0,0,0-1-2.07,3.12,3.12,0,0,0-4.06,0,3.35,3.35,0,0,0-1,2.07Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M382.37,380.21l-6.09-18.08H383l3.23,13,3.26-13h6.09l-6.09,18.08Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M396.46,368.25a15.18,15.18,0,0,1,.42-3.52,24.22,24.22,0,0,1,1.13-3.58c.48-1.2,1.05-2.43,1.7-3.68s1.36-2.51,2.12-3.8l5,2c-.27.43-.65,1.1-1.12,2s-.94,1.94-1.41,3.11a32,32,0,0,0-1.22,3.73,15.3,15.3,0,0,0-.51,3.83,15,15,0,0,0,1.18,5.71c.8,1.92,1.76,4,2.91,6.12l-4.74,2.3c-.72-1.05-1.4-2.16-2-3.32a34.12,34.12,0,0,1-1.74-3.54,24.46,24.46,0,0,1-1.2-3.66A15.69,15.69,0,0,1,396.46,368.25Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M418.22,368.25a15.67,15.67,0,0,1-.44,3.71,24.46,24.46,0,0,1-1.2,3.66,34.12,34.12,0,0,1-1.74,3.54c-.65,1.16-1.34,2.27-2,3.32l-4.74-2.3q1.71-3.24,2.9-6.12a14.32,14.32,0,0,0,.67-9.54,30.19,30.19,0,0,0-1.22-3.73c-.47-1.17-.94-2.21-1.41-3.11s-.84-1.58-1.11-2l5-2c.76,1.29,1.46,2.55,2.12,3.8s1.22,2.48,1.7,3.68a24.22,24.22,0,0,1,1.13,3.58A15.17,15.17,0,0,1,418.22,368.25Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevLogo);
export default __webpack_public_path__ + "static/media/dev_logo.123ab99cbb9555ebdce49085925b0833.svg";
export { ForwardRef as ReactComponent };